import React, { Component } from "react";
import WhatsAppWidget from 'react-whatsapp-widget';
import 'react-whatsapp-widget/dist/index.css';
import {FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/FotolabGuatemala'},
    {Social: <FaLinkedinIn /> , link: 'https://linkedin.com/company/fotolab'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/fotolabguatemala'},
]
class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left">
                                    <div className="inner">         
                                        <span>Captura la Vida</span>
                                        <h2>Inmortaliza <br /> tus memorias</h2>
                                        <WhatsAppWidget phoneNumber='50249451326' textReplyTime='Estaremos respondiendo a la mayor brevedad posible.' message='Hola! 👋🏼 ¿Como te llamas y como podemos ayudarte?' companyName='Fotolab' sendButton='Enviar'/>  
                                        <a className="rn-button-style--2" href="/contact">
                                            <span>Contactanos</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link">
                                                <h4>Enlaces</h4>
                                                <ul className="ft-link">
                                                    <li><a href="/portfolio">Servicios</a></li>
                                                    <li><a href="/service">Productos</a></li>
                                                    <li><a href="/contact">Hablanos</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4>Saludanos</h4>
                                                <ul className="ft-link">
                                                    <li><a href="mailto:hola@fotolab.com.gt">hola@fotolab.com.gt</a></li>
                                                </ul>
                                                <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                                </div> 
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>Copyright © 2021 Silibrain LLC. All Rights Reserved.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;